import { render, staticRenderFns } from "./VoiceBotList.vue?vue&type=template&id=6fb6a239&scoped=true&"
import script from "./VoiceBotList.vue?vue&type=script&lang=js&"
export * from "./VoiceBotList.vue?vue&type=script&lang=js&"
import style0 from "./VoiceBotList.vue?vue&type=style&index=0&id=6fb6a239&prod&lang=scss&scoped=true&"
import style1 from "./VoiceBotList.vue?vue&type=style&index=1&id=6fb6a239&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb6a239",
  null
  
)

export default component.exports